import styled from 'styled-components';

export const UploadFileContainer = styled.div`
    width: fit-content;
    h6 {
        color: ${({ theme }) => theme.palette.brand['brand-01']};
        cursor: pointer;
    }
`;
